/**
 *  oss api
 *  @author cpc
 */
import * as API from '..'
import $const from '../../common/constant'

export default {
  /**
   * get upload token
   * @param params
   * @returns  result upload token
   */
  token: type => {
    return API.GET($const.apiServer.Base + '/oss/token/' + type);
  },
  /**
   * get download url
   * @param params
   * @returns {Promise<*>}
   */
  downloadUrl: params => {
    return API.GET($const.apiServer.Base + '/oss/downloadUrl', params);
  }
}





// WEBPACK FOOTER //
// ./src/api/oss/api_coss.js